import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component, computed, signal } from "@angular/core";
import {
  BulkUploadFieldPreview,
  BulkUploadRowPreview,
  SupportedBulkUploadEntityModel,
} from "@m19-board/services/bulk-upload/bulk-upload-context.service";
import { ITooltipDirective, IBadgeComponent } from "@front/m19-ui";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-bulk-upload-cell-renderer",
  templateUrl: "./bulk-upload-cell-renderer.component.html",
  imports: [ITooltipDirective, NgClass, IBadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadCellRendererComponent<T extends SupportedBulkUploadEntityModel>
  implements ICellRendererAngularComp
{
  protected parsedEntity = signal<Partial<T> | undefined>(undefined);
  protected fieldPreview = signal<BulkUploadFieldPreview<T> | null | undefined>(undefined);

  protected readonly formattedChangedValue = computed(() => {
    if (!this.fieldPreview()?.hasChanged) return undefined;

    if (this.fieldPreview()?.parsedValue === undefined) return `Deleted ${this.fieldPreview()?.existingValue}`;
    else if (this.fieldPreview()?.parsedValue !== undefined && this.fieldPreview()?.existingValue === undefined)
      return `Added ${this.fieldPreview()?.parsedValue}`;
    else return `${this.fieldPreview()?.existingValue} -> ${this.fieldPreview()?.parsedValue}`;
  });

  agInit(params: ICellRendererParams<BulkUploadRowPreview<T>, BulkUploadFieldPreview<T>>): void {
    this.parsedEntity.set(params.data?.parsedEntity);
    this.fieldPreview.set(params.value);
  }

  refresh(_: ICellRendererParams<BulkUploadRowPreview<T>>): boolean {
    return true;
  }
}
